import React, { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faExclamationCircle,
    faPlugCircleXmark,
    faPlugCircleCheck
} from '@fortawesome/free-solid-svg-icons';

// We now read the data from IndexedDB using localforage
import { getAll } from '../../storage/offlineSurveysStore'; // adjust the path if necessary

export default function ConnectionStatus() {
    const isOnline = useSelector((state) => state.onlineStatus.isOnline);
    const [unsyncedCount, setUnsyncedCount] = useState(0);

    /**
     * Refresh the count of unsynchronized surveys stored offline.
     */
    const refreshUnsyncedCount = useCallback(async () => {
        try {
            const offlineSurveys = await getAll();
            setUnsyncedCount(Object.keys(offlineSurveys).length);
        } catch (error) {
            setUnsyncedCount(0);
        }
    }, []);

    useEffect(() => {
        // 1) Load count on mount
        refreshUnsyncedCount();

        // 2) Update when the offline store changes (insert/remove/clear/migrate)
        const handleStoreChange = () => refreshUnsyncedCount();
        window.addEventListener('offlineSurveys:changed', handleStoreChange);

        // 3) Also refresh when the network state changes
        window.addEventListener('online', handleStoreChange);
        window.addEventListener('offline', handleStoreChange);

        return () => {
            window.removeEventListener('offlineSurveys:changed', handleStoreChange);
            window.removeEventListener('online', handleStoreChange);
            window.removeEventListener('offline', handleStoreChange);
        };
    }, [refreshUnsyncedCount]);

    return (
        <div
            className="position-fixed d-flex align-items-center connection-status"
            style={{
                backgroundColor: 'white',
                padding: '10px 15px',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                zIndex: 1000
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '0.9rem',
                    color: isOnline ? '#28a745' : '#dc3545',
                    fontWeight: 'bold'
                }}
            >
                {unsyncedCount > 0 && (
                    <span style={{ color: 'white' }}>
            <span
                className="badge bg-danger"
                title="Unsynchronized surveys"
            >
              <FontAwesomeIcon className="px-1" icon={faExclamationCircle} />
                {unsyncedCount}
            </span>
          </span>
                )}

                <FontAwesomeIcon
                    icon={isOnline ? faPlugCircleCheck : faPlugCircleXmark}
                />
                <span className="d-none d-md-inline">
          {isOnline ? 'En ligne' : 'Hors ligne'}
        </span>
            </div>
        </div>
    );
}
